import { tokens, Text } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const S = {
  Card: styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${tokens.color.ui_background};
    border: 1px solid ${tokens.color.ui_border};
    border-radius: ${tokens.radius.m};
    padding: ${tokens.spacer.x2};
  `,
  CardTitle: styled(Text)`
    margin-bottom: ${tokens.spacer.x1};
  `,
};

interface Props {
  children: React.ReactNode | React.ReactNode[];
  title?: string;
  className?: string;
}

export function FlatCard({ children, title, className }: Props): JSX.Element {
  return (
    <S.Card className={className}>
      {title !== undefined ? <S.CardTitle textType="subtitle2">{title}</S.CardTitle> : null}
      {children}
    </S.Card>
  );
}
